import { Component, OnInit,Input,EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VoiceBatchService } from '../../../service/voice/voice-batch.service';
import {NgbModal, ModalDismissReasons,NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

import { BatchCalls } from '../../../model/batch-calls'
import { BatchCallDetails } from '../../../model/batch-call-details'
import { LoadedRouterConfig } from '@angular/router/src/config';

import { DropdownService } from '../../../service/voice/dropdown.service'
import { Dropdown } from '../../../model/dropdown';

import { CallHistory } from './call-history'
import * as moment from 'moment'
import { Alert } from 'selenium-webdriver';

@Component({
  selector: 'app-voice-detail',
  templateUrl: './voice-detail.component.html',
  styleUrls: ['./voice-detail.component.scss']
})
export class VoiceDetailComponent implements OnInit {

  mytime:Date = new Date;

  showSched:boolean = false;

  public selectedMoment = new Date();
  public dateTime: Date;
  private batch:BatchCalls = new BatchCalls

  private batch_details:BatchCallDetails[] = []
  selectedFile: File
  private batch_id:any = 0;
  private loading:boolean = false;

  
  private batch_types:Dropdown[] = []
  
  private call_types:Dropdown[] = []

  constructor(private http:VoiceBatchService,
              private modalService: NgbModal,
              private route:ActivatedRoute,
              private drp:DropdownService
              ) { 
                
              }

  ngOnInit() {
     this.route.params.subscribe(
       (params) => {
         if(params['id']){
          this.batch_id = params.id;
          //pass the parmeter on the component
          this.loadDetails(this.batch_id)
         }else{
          this.loadDropdown();
         }
       }
     )
     
     
  }

  loadDetails(batch_id){
     this.http.getBatch(batch_id).subscribe(
       (data) => {
          this.batch = <BatchCalls>data[0];
          alert('Load Details' + JSON.stringify(this.batch))
          this.loadDropdown()
       },
       (err) => {
         alert(err)
       }
     )
     
  }


  loadDropdown(){
    this.drp.getBatchDetailDropdown().subscribe(
      (data) => {
        this.batch_types = data['batch_type'];
        this.call_types = data['call_type'];

        if(this.batch_id == 0){
          this.batch.batch_type_id = 1
          this.batch.call_type_id = 1
        }
        
      },
      (err) => {
        alert("Error Loaddropdown:"  + JSON.stringify(err))
      }
    )
   
  }
  

  callSponsors(){
      const bid = this.batch_id;
      if(bid==0){
        alert('Cannot call zero batch ID');
      }else{
        this.http.callSponsors(bid).subscribe(
          (data) => {
             alert('Succesfully Called on que:' + data)
          }
        )
      }
     
  }
  
  callSponsorsBySchedule(){
    const bid = this.batch_id;
      if(bid==0){
        alert('Cannot call zero batch ID');
      }else{
        let dtp = moment(this.mytime).format("YYYY-MM-DD HH:mm:ss")
          const data = {
            "date_selected" : dtp,
            "batch_id" : this.batch_id
          }
          
          this.http.callSponsorsBySchedule(data).subscribe(
            (data) => {
              alert("Successfully set the schedule:" + JSON.stringify(data))
            },
            (err) => alert('Error:' + JSON.stringify(err))
          )
      }
    
  }

  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
    
  }

  onUpload() {
    // upload code goes here
    //alert(this.selectedFile.name)
    //alert(JSON.stringify(this.batch))
    const uploadData = new FormData();
    uploadData.append('excel', this.selectedFile);
    uploadData.append('batch_type_id',<any>this.batch.batch_type_id)
    uploadData.append('call_type_id', <any>this.batch.call_type_id)
    if(this.batch_id > 0){
      uploadData.append('batch_id', this.batch_id)
    }
    
    this.http.uploadVoiceDetails(uploadData).subscribe(
      (res) => {
             //this.loadDetails(res['batch_id'])
             this.batch_id = res['batch_id'];
             alert('Import successfull')
         },
      (err) => alert("Error uploading voice details:" + JSON.stringify(err['error']['message'])) 
    )
  }

  //Load Call History
  loadCallHistory(batch_detail_id){
    //alert('Batch ID:' + batch_detail_id)
      //this.appContactsProfile.open();
  }

  closeResult: string;




  // showPicker = false;
  //   myDate: Date = new Date();
  //   showDate = true;
  //   showTime = true;
  //   closeButton: any = { show: true, label: 'Close Me!', cssClass: 'btn btn-sm btn-primary' };

  //   onTogglePicker() {
  //       if (this.showPicker === false) {
  //           this.showPicker = true;
  //       }
  //   }

  //   onValueChange(val: Date) {
  //       this.myDate = val;
  //   }

  //   isValid(): boolean {
  //     // this function is only here to stop the datepipe from erroring if someone types in value
  //       return this.myDate && (typeof this.myDate !== 'string') && !isNaN(this.myDate.getTime());
  //   }


}

